export default __webpack_public_path__ + "static/specs-2de4de7a37dcaede1d6e14835b9ca160.png";